// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__Rckko","avatar--small":"style_avatar--small__k6dCe","avatar--medium":"style_avatar--medium__ex2p7","avatar--large":"style_avatar--large__7lyW2"};